import { render, staticRenderFns } from "./PCBScreeningSchema.vue?vue&type=template&id=2f5b8756&scoped=true&"
import script from "./PCBScreeningSchema.vue?vue&type=script&lang=js&"
export * from "./PCBScreeningSchema.vue?vue&type=script&lang=js&"
import style0 from "./PCBScreeningSchema.vue?vue&type=style&index=0&id=2f5b8756&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b8756",
  null
  
)

export default component.exports